import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";

import { AuthLayout } from "AuthLayout";
import { PrivateLayout } from "PrivateLayout";
import { PublicLayout } from "PublicLayout";
import { NotFoundPage } from "NotFoundPage";

import LoginScreen from "modules/login/LoginScreen";
import { VisaoGeral } from "modules/visaoGeral/VisaoGeral";
import { GestaoCobranca } from "modules/gestaocobranca/abaGestaoDeCobrancas/GestaoCobranca";
import { GestaoCobrancaCadastro } from "modules/gestaocobranca/gestaoCobrancaCadastro/GestaoCobrancaCadastro";
import { Rotas } from "constants/EnumRotas";
import { GestaoCobrancaCadastroProvider } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { AgendamentoContatoProvider } from "context/gestaoCobranca/AgendamentoContatoContext";
import ProcessosJudiciais from "modules/gestaocobranca/abaProcessosJudicias/ProcessosJudiciais";
import { ProcessosJudiciaisProvider } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { PermissoesContextProvider } from "context/permissoes/PermissoesContext";
import GroupPay from "modules/groupPay/GroupPay";
import TelaPropostaComercialGroupPay from "modules/groupPay/ativacaoGroupPay/TelaPropostaComercialGroupPay";
import TelaAtivacaoConcluidaGroupPay from "modules/groupPay/ativacaoGroupPay/TelaAtivacaoConcluidaGroupPay";
import ContaDigital from "modules/contaDigital/ContaDigital";
import TelaConfiguracoesGroupPay from "modules/groupPay/configuracaoGroupPay/TelaConfiguracoesGroupPay";
import TelaListaDespesasGroupPay from "modules/groupPay/listaDespesasGroupPay/TelaListaDepesasGroupPay";
import GroupSign from "modules/groupSign/GroupSign";
import { VisualizarAssinaturasDigitalCondominio } from "modules/groupSign/configuracaoCondominio/VisualizarAssinaturasDigitalCondominio";
import { GerenciarConfiguracaoDocumento } from "modules/groupSign/configuracaoDocumento/GerenciarConfiguracaoDocumento";
import { GestaoAssinatura } from "modules/groupSign/gestaoAssinatura/GestaoAssinatura";
import TelaInicialAtivacaoGroupSign from "modules/groupSign/ativacaoGroupSign/TelaInicialAtivacaoGroupSign";
import TelaAtivacaoConcluidaGroupSign from "modules/groupSign/ativacaoGroupSign/TelaAtivacaoConcluidaGroupSign";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<AuthLayout />}>
        <Route element={<PublicLayout />}>
          <Route path={Rotas.LOGIN} element={<LoginScreen />} />
        </Route>

        <Route
          path="/"
          element={
            <PermissoesContextProvider>
              <PrivateLayout />
            </PermissoesContextProvider>
          }
        >
          <Route path={Rotas.VISAO_GERAL} element={<VisaoGeral />} />
          <Route
            path={Rotas.GESTAO_DE_COBRANCAS}
            element={
              <>
                <AgendamentoContatoProvider>
                  <ProcessosJudiciaisProvider>
                    <GestaoCobranca />
                  </ProcessosJudiciaisProvider>
                </AgendamentoContatoProvider>
              </>
            }
          />
          <Route
            path={`${Rotas.GESTAO_COBRANCAS_CADASTRO}`}
            element={
              <GestaoCobrancaCadastroProvider>
                <GestaoCobrancaCadastro />
              </GestaoCobrancaCadastroProvider>
            }
          />

          <Route
            path={`${Rotas.PROCESSOS_JUDICIAIS}`}
            element={
              <ProcessosJudiciaisProvider>
                <ProcessosJudiciais />
              </ProcessosJudiciaisProvider>
            }
          />

          <Route path={`${Rotas.CONTA_DIGITAL}`} element={<ContaDigital />} />

          <Route path={`${Rotas.GROUP_PAY}`} element={<GroupPay />} />
          <Route path={`${Rotas.GROUP_PAY_PROPOSTA_COMERCIAL}`} element={<TelaPropostaComercialGroupPay />} />
          <Route path={`${Rotas.GROUP_PAY_ATIVACAO_CONCLUIDA}`} element={<TelaAtivacaoConcluidaGroupPay />} />
          <Route path={`${Rotas.GROUP_PAY_CONFIGURAR}`} element={<TelaConfiguracoesGroupPay />} />
          <Route path={`${Rotas.GROUP_PAY_LISTA_DESPESAS}`} element={<TelaListaDespesasGroupPay />} />
          {/* <Route path={`${Rotas.GROUP_PAY_DETALHE_DESPESA}`} element={<TelaDetalheDespesaGroupPay />} /> */}
          <Route path={`${Rotas.ASSINATURA_DIGIAL_CONFIGURACAO}`} element={<GroupSign />} />
          <Route
            path={`${Rotas.ASSINATURA_DIGITAL_CONFIGURACAO_CONDOMINIO}`}
            element={<VisualizarAssinaturasDigitalCondominio />}
          />
          <Route
            path={`${Rotas.ASSINATURA_DIGITAL_CONFIGURACAO_DOCUMENTO}`}
            element={<GerenciarConfiguracaoDocumento />}
          />
          <Route path={`${Rotas.ASSINATURA_DIGITAL_GESTAO}`} element={<GestaoAssinatura />} />
          <Route path={`${Rotas.ASSINATURA_DIGITAL_PROPOSTA_COMERCIAL}`} element={<TelaInicialAtivacaoGroupSign/>}/>
          <Route path={`${Rotas.ASSINATURA_ATIVACAO_CONCLUIDA}`} element={<TelaAtivacaoConcluidaGroupSign />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </>
  ),
  { basename: "/v2" }
);
